// src/components/modalForm/ModalHeader.js
import React from 'react';
import { FiEdit3, FiSearch, FiX } from 'react-icons/fi';
import './ModalHeader.css';
import { useModalForm } from './ModalFormContext';

const normalizeHeaderColor = (value) => {
  if (typeof value !== 'string') return undefined;
  const hex = value.trim().replace(/^#/, '');
  return /^[0-9a-f]{6}$/i.test(hex) ? `#${hex.toUpperCase()}` : undefined;
};

const ModalHeader = ({ children, title, subtitle, onHide, className = '', icon, closeDisabled = false, closeLabel = 'Fechar janela', headerColors }) => {
  const { variant, titleId } = useModalForm();
  const Icon = icon || (variant === 'busca' ? FiSearch : FiEdit3);
  const backgroundColor = normalizeHeaderColor(headerColors?.backgroundColor);
  const textColor = normalizeHeaderColor(headerColors?.textColor);
  return (
    <div
      className={`modal-header modal-header-compact${backgroundColor ? ' modal-header-custom-background' : ''}${textColor ? ' modal-header-custom-color' : ''} ${className}`.trim()}
      style={backgroundColor || textColor ? { backgroundColor, color: textColor, '--modal-header-text-color': textColor } : undefined}
    >
      {title !== undefined && (
        <div className="modal-heading">
        <h5 className="modal-title" id={titleId}>
          {variant !== 'legacy' && <Icon className="modal-title-icon" aria-hidden="true" />}
          <span>{title}</span>
        </h5>
        {subtitle && <small className="modal-subtitle">{subtitle}</small>}
        </div>
      )}
      {children}
      {onHide && <button type="button" className="modal-close" aria-label={closeLabel} disabled={closeDisabled} onClick={onHide}><FiX aria-hidden="true" /></button>}
    </div>
  );
};

export default ModalHeader;
